const DEFAULT_GATES = { AlcoholGate: false, BettingGate: false, regionSuffix: null };

/**
 * Resolves AlcoholGate, BettingGate, and regionSuffix from the master manifest
 * for a given user location, following a strict four-level priority order:
 *
 * 1. US State-Level Override  — countryCodeAlpha3 === "USA" and region key exists in USRegions
 * 2. USA Country-Level        — countryCodeAlpha3 === "USA" and "USA" key exists in Countries
 * 3. Country-Level Match      — countryCodeAlpha3 key exists in Countries (non-USA countries)
 * 4. Global Fallback          — Countries.DEFAULT entry (defaults to false/false if absent)
 */
export const resolveDemographicGates = ({
  countryCodeAlpha3,
  region,
  manifestData,
}) => {
  if (!manifestData) return DEFAULT_GATES;

  // Priority 1: US state-level override
  if (
    countryCodeAlpha3 === "USA" &&
    region &&
    manifestData.USRegions?.[region]
  ) {
    const stateEntry = manifestData.USRegions[region];
    return {
      AlcoholGate: stateEntry.AlcoholGate,
      BettingGate: stateEntry.BettingGate,
      regionSuffix: region,
    };
  }

  // Priority 2: USA country-level fallback — applies when the user is in the US
  // but their state is not represented in USRegions. Must check Countries["USA"]
  // before falling through to the generic country match or DEFAULT.
  if (countryCodeAlpha3 === "USA" && manifestData.Countries?.["USA"]) {
    const usaEntry = manifestData.Countries["USA"];
    return {
      AlcoholGate: usaEntry.AlcoholGate,
      BettingGate: usaEntry.BettingGate,
      regionSuffix: null,
    };
  }

  // Priority 3: Country-level match (non-USA countries)
  if (countryCodeAlpha3 && manifestData.Countries?.[countryCodeAlpha3]) {
    const countryEntry = manifestData.Countries[countryCodeAlpha3];
    return {
      AlcoholGate: countryEntry.AlcoholGate,
      BettingGate: countryEntry.BettingGate,
      regionSuffix: null,
    };
  }

  // Priority 4: Global fallback via DEFAULT
  return {
    AlcoholGate: manifestData.Countries?.DEFAULT?.AlcoholGate ?? false,
    BettingGate: manifestData.Countries?.DEFAULT?.BettingGate ?? false,
    regionSuffix: null,
  };
};
